/**
 * @generated SignedSource<<4279c754952540e636b3f28946a98a1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Error404Layout_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CategoryTiles_viewer">;
  readonly " $fragmentType": "Error404Layout_viewer";
};
export type Error404Layout_viewer$key = {
  readonly " $data"?: Error404Layout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Error404Layout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Error404Layout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CategoryTiles_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d5b245090396300971343a3c39ceca98";

export default node;
